import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { TENANT_NAME } from './config/tenants';
import { translations } from './translations';

const translation = translations[TENANT_NAME];

const resources = {
  en: {
    translation: translation.en,
  },
  pl: {
    translation: translation.pl,
  },
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: 'pl',
  });

export default i18n;
